
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/heroes",
      function () {
        return require("private-next-pages/heroes/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/heroes"])
      });
    }
  